import { combineReducers } from "redux";
import upiriaReducer from "./upiria/reducer";

const rootReducer = combineReducers({
  upiria: upiriaReducer,
});

export default rootReducer;
